import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import $ from 'jquery';


( function() {    

    // Image Lightbox
    $(".reference-archive article").on( 'click', function() {

        const lightbox = new PhotoSwipeLightbox({
            dataSource: JSON.parse( $(this).find('a').attr("data-images") ),
            pswpModule: PhotoSwipe
        });

        // Caption
        lightbox.on('uiRegister', function() {

            lightbox.pswp.ui.registerElement({
                name: 'caption',
                isButton: false,
                appendTo: 'root',
                onInit: ( el ) => {
                    lightbox.pswp.on('change', () => {

                        let currentSlide = lightbox.pswp.currSlide;
                        let title = currentSlide.data.title;

                        if( ! title.length ) {
                            return
                        }

                        $(el)
                            .css("width", currentSlide.content.displayedImageWidth)
                            .css("bottom", "max(0%, calc(50% - " + currentSlide.content.displayedImageHeight/2 + "px)" )
                            .html(title)
                    });
                }
    
            });
    
        });

        
        lightbox.init(); // initializing PhotoSwipe core adds it to DOM
        lightbox.loadAndOpen(0); 
    });


    // Filter
    $(".reference-filter .filter a").on( 'click', function(e) {

        e.preventDefault();

        // Beim erneuten Klicken, Filter deaktivieren
        if( $(this).closest(".filter").hasClass("active") ) {
            $(".reference-filter .unfilter a").trigger("click");
            return
        }

        // Filter-Slug holen
        let type = $(this).attr("href").slice(1); // # am Anfang entfernen

        // Filter (de-)aktivieren
        $(".reference-filter .filter").removeClass("active");
        $(this).closest(".filter").addClass("active");

        // Referenzen filtern
        $(".reference-archive article").each( function() {
            $(this).toggleClass( "hidden", type && ! $(this).hasClass( type ) );
        })

    });

} )()